export enum Card {
  CREATE_TOKENIZED_CARD_REQUEST = '@app/CREATE_TOKENIZED_CARD_REQUEST',
  CREATE_TOKENIZED_CARD_SUCCESS = '@app/CREATE_TOKENIZED_CARD_SUCCESS',
  CREATE_TOKENIZED_CARD_FAIL = '@app/CREATE_TOKENIZED_CARD_FAIL',

  GET_CARD_REQUEST = '@app/GET_CARD_REQUEST',
  GET_CARD_SUCCESS = '@app/GET_CARD_SUCCESS',
  GET_CARD_FAIL = '@app/GET_CARD_FAIL',

  DELETE_CARD_REQUEST = '@app/DELETE_CARD_REQUEST',
  DELETE_CARD_SUCCESS = '@app/DELETE_CARD_SUCCESS',
  DELETE_CARD_FAIL = '@app/DELETE_CARD_FAIL',
}
